import { createElement, useEffect, useState } from 'react';
import Check from '@mui/icons-material/Check';
import type { UseMutationResult } from '@tanstack/react-query';
import { cx } from '@/utils';
import styles from './style/OptimisticIndicator.module.css';

type Props = {
  classes?: {
    root?: string;
    icon?: string;
  };
  Icon?: React.ComponentType;
} & Pick<UseMutationResult,
  | 'isError'
  | 'isPending'
  | 'isSuccess'>;

export const OptimisticIndicator = ({ classes = {}, ...props }: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {

    if (!visible && props.isSuccess) {
      setVisible(true);
    }

    if (visible && props.isPending) {
      setVisible(false);
    }

  }, [props.isSuccess, props.isPending, visible]);

  const rootclasses = cx(styles.root, {
    [styles.enter]: visible,
  }, classes.root);

  return (
    <span className={rootclasses}>
      <Icon
        as={props.Icon}
        classes={classes} />
    </span>
  );
};

type IconProps = {
  as?: Props['Icon'];
  classes?: Pick<Props['classes'], 'icon'>;
};

const Icon = ({ classes = {}, ...props }: IconProps) => {
  return props.as
    ? createElement(props.as)
    : <Check className={classes.icon} />;
};

Icon.displayName = 'OptimisticIndicator.Icon';